module.exports = __webpack_public_path__ + "images/menu-517cdf1d6308d49c0b7b252ba50bab21.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/menu.svg
// module id = ./client/assets/images/menu.svg
// module chunks = 1 6 7 8 9